export default __webpack_public_path__ + "static/media/img_vmax-colorBkg.4f1e39c9.png";